import * as React from "react";
import PropTypes from "prop-types";

function ProgressBar({ end = 0, start = 0, style }) {
  const styles = {
    ...style,
    left: `${start}%`,
    width: `${end - start}%`
  };

  return <div style={styles} className="oui-slider-progress-bar" />;
}

ProgressBar.propTypes = {
  style: PropTypes.object,
  start: PropTypes.number.isRequired,
  end: PropTypes.number.isRequired
};

ProgressBar.defaultProps = {
  style: {}
};

ProgressBar.displayName = "OrionSliderProgressBar";

export default ProgressBar;
